// import { CTableRow } from '@coreui/react'
// import { CChartLine } from '@coreui/react-chartjs'
// import { getStyle, hexToRgba } from '@coreui/utils'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { del, get } from 'src/services/http-service'
import {
  ENDPOINT_DELETE_GAME_IMAGE,
  ENDPOINT_GET_GAME_IMAGES_NAMES,
  GAME_IMAGES_PATH,
} from 'src/variables'
import {
  CButton,
  CImage,
  CCol,
  CModal,
  CModalBody,
  CRow,
  CSpinner,
  CModalFooter,
} from '@coreui/react'

const ManageGameImages = () => {
  // const random = (min, max) => Math.floor(Math.random() * (max - min + 1) + min)
  const userToken = useSelector((state) => state.user.token)
  const userName = useSelector((state) => state.user.username)
  const [gameImagesNames, setGameImagesNames] = useState([])
  const [selectedImageName, setSelectedImageName] = useState()
  const [deleteState, setDeleteState] = useState('not_sent')

  useEffect(() => {
    async function fetchGameImagesNames() {
      const res = await get({
        endpoint: ENDPOINT_GET_GAME_IMAGES_NAMES,
        bearerToken: userToken,
      })
      let parsed = []
      const hash = await sha256(userName)
      for (let k in res) {
        const check = res[k].split('-')
        if (check[0] === hash) parsed.push(res[k])
      }

      setGameImagesNames(parsed)
    }

    if (userToken) {
      fetchGameImagesNames()
    }
  }, [userToken])

  async function sha256(source) {
    const sourceBytes = new TextEncoder().encode(source)
    const digest = await crypto.subtle.digest('SHA-256', sourceBytes)
    const resultBytes = [...new Uint8Array(digest)]
    return resultBytes.map((x) => x.toString(16).padStart(2, '0')).join('')
  }

  async function deleteImage(imageName) {
    try {
      setDeleteState('pending')
      await del({
        endpoint: ENDPOINT_DELETE_GAME_IMAGE,
        bearerToken: userToken,
        data: {
          imageName,
        },
      })
      const imageIndex = gameImagesNames.indexOf(imageName)
      let newGameImagesNames = [...gameImagesNames]
      newGameImagesNames.splice(imageIndex, 1)
      setGameImagesNames(newGameImagesNames)
      setDeleteState('success')
    } catch (err) {
      setDeleteState('failure')
    }
  }

  const gameImagesHtml = gameImagesNames.map((gameImageName) => (
    <CCol style={{ marginBottom: '25px' }} key={gameImageName} sm={12} md={6} lg={4}>
      <div onClick={() => setSelectedImageName(gameImageName)}>
        <CImage className="upload-img" src={`${GAME_IMAGES_PATH}/${gameImageName}`} />
      </div>
    </CCol>
  ))

  return (
    <>
      <CRow>{gameImagesHtml}</CRow>
      <CModal
        alignment="center"
        className="show position-fixed"
        keyboard={false}
        portal={false}
        visible={!!selectedImageName}
        onClose={() => {
          if (deleteState !== 'pending') {
            setSelectedImageName()
            setDeleteState('not_sent')
          }
        }}
      >
        <CModalBody>
          <CRow className="justify-content-center align-items-center">
            <CCol className="text-center">
              {deleteState === 'not_sent' && <div className="breakword">{selectedImageName}</div>}
              {deleteState === 'pending' && <CSpinner />}
              {deleteState === 'success' && <span>Immagine cancellata con successo!</span>}
              {deleteState === 'failure' && (
                <span>{"Non é stato possibile cancellare l'immagine, riprova piú tardi"}</span>
              )}
            </CCol>
          </CRow>
        </CModalBody>
        <CModalFooter>
          {selectedImageName && (deleteState === 'not_sent' || deleteState === 'pending') && (
            <CButton
              disabled={deleteState === 'pending'}
              color="danger"
              onClick={() => deleteImage(selectedImageName)}
            >
              Cancella
            </CButton>
          )}
          <CButton
            onClick={() => {
              setSelectedImageName()
              setDeleteState('not_sent')
            }}
          >
            Chiudi
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ManageGameImages
